import React, { useEffect } from 'react';

import { toast } from "react-toastify";
toast.configure();

const ToastWrapper = ({msg, children})=> {

  useEffect(()=> {
    renderRedirectError();
  } ,[]);

  const renderRedirectError = () => {

    if(!msg || !msg?.text) return;
    toast[msg.type](msg.text, {
      position     : toast.POSITION.BOTTOM_CENTER,
      toastId      : "thirdPartyAuthFailed",
      closeOnClick : true,
      theme        : "colored",
    })
  }

  return children;
}

export default ToastWrapper;
